<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/pay' }">结算管理</el-breadcrumb-item>
            <el-breadcrumb-item>服务结算</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="form-box">
            <div class="tips-area text-center">
                <div class="tips-area__icon">
                    <i class="el-icon-check"></i>
                </div>
                <div class="tips-area__msg">
                    服务结算成功
                </div>
                <div class="tips-area__footer">
                    <el-button @click="goPage('/index/pay/record')" type="primary">查看结算详情</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Step3',
    inject: ['back', 'goPage', 'tel']
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/sub";
    .tips-area {
        margin-top: 114px;
        .tips-area__icon {
            display: inline-block;
            border-radius: 50%;
            color: #fff;
            line-height: 108px;
            font-size: 48px;
            width: 100px;
            height: 100px;
            background-color: $--color-primary;
        }
        .tips-area__msg {
            margin-top: 28px;
            margin-bottom: 56px;
        }
        .tips-area__footer {

        }
    }
</style>
